import api from 'service/api'

const dponetAPI = api.create('dponet', false)

const exportsRipd = async (data) => {
  return await dponetAPI.post('/ripds/export', data)
}

export default { exportsRipd }
